import store from '../store';

export default function pulse({ next, router }) {
  if(!store.getters['profile/user'].pulse) {
    return router.push({ path: "/home" });
  }

  return next();
}